const initialState = {
  nextButtonTriggered: false,
};

export default function NavigationReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case "NEXT_BUTTON_TRIGGER":
      return {
        ...state,
        nextButtonTriggered: payload,
      };
    default:
      return state;
  }
}
